import { MutationTree, GetterTree } from "vuex";
import * as mutationTypes from "./mutations.type";

export interface State {
  breadcrumbs: BreadcrumbItem[];
}

export interface BreadcrumbItem {
  label: string;
  path: string;
}

export const state: State = {
  breadcrumbs: [],
};

export const mutations: MutationTree<State> = {
  [mutationTypes.SET_BREADCRUMBS](state, crumbs: BreadcrumbItem[]) {
    state.breadcrumbs = crumbs;
  },

  [mutationTypes.RESET](state, newState: any) {
    Object.assign(state, newState);
  },
};

export const getters: GetterTree<State, State> = {
  breadcrumbs: state => {
    return state.breadcrumbs;
  },
};
